import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';

function DashboardNoRecord({ text }) {
  return (
    <div className="border-yellow-400 border-l-4 bg-yellow-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <ExclamationTriangleIcon
            aria-hidden="true"
            className="size-5 text-yellow-400"
          />
        </div>
        <div className="ml-3">
          <p className="text-sm text-yellow-700">{text}</p>
        </div>
      </div>
    </div>
  );
}

DashboardNoRecord.propTypes = {
  text: PropTypes.string.isRequired,
};

export default DashboardNoRecord;
